import moment from 'moment'
import cache from '../helpers/cache'
import { DATE_RANGE } from '../helpers/config'

const getDateRange = () => (cache.getItem(DATE_RANGE))

const setDateRange = (dateRange) => {
    cache.setItem(DATE_RANGE, dateRange || [])
}

/**
 * If the string is a timestamp, convert it to DD MMM format
 * @function getTimeIfValid
 * @param {String} data
 * @return {String} 
 */
const getTimeIfValid = (data) => {
    return (moment(data).toDate().toString() !== "Invalid Date") ?
        moment(data).format('DD/MM/YYYY hh:mm:ss A') :
        data
}

/**
 * convert timestamp axis labels to DD MMM format
 * @exports
 * @function formatTimeStrings 
 * @param {Array} dataSet 
 * @returns {Array} updatedPivot where the timestamps are converted to DD MMM
 */
const formatTimeStrings = (dataSet) => {
    let updatedPivot = dataSet.map((item) => {
        let updatedX = item.xValues.map((x) => {
            return getTimeIfValid(x)
        })
        return {
            ...item,
            category: getTimeIfValid(item.category),
            x: getTimeIfValid(item.x),
            xValues: updatedX
        }
    })

    return updatedPivot
}

const mapDateRangeToTimeDimensions = (timeDimRange, tableName, timeColumn, prevTimeDimensions) => {
    let updatedTimeDimensions

    if (prevTimeDimensions !== undefined && prevTimeDimensions.length > 0) {
        // if the time dimensions already exist, modify it by adding the date range
        // if startDate or endDate are undefined then there is no date range (all time)
        updatedTimeDimensions = prevTimeDimensions.map((item) => {
            delete item['dateRange']
            return {
                ...item,
                ...(
                    !!timeDimRange && timeDimRange.length > 0 ?
                        { dateRange: timeDimRange.map(date => moment(date).format('YYYY-MM-DD')) } :
                        {}
                )
                // dateRange: timeDimRange.map(date => moment(date).format('YYYY-MM-DD'))
            }
        })
    }
    else {
        // if the time dimensions dont exist, add a new time dimension 
        updatedTimeDimensions = !!timeDimRange && timeDimRange.length > 0 ? [
            {
                dimension: `${tableName}.${timeColumn}`,
                dateRange: timeDimRange.map(date => moment(date).format('YYYY-MM-DD'))
            }
        ] : []

    }
    return updatedTimeDimensions
}

const mapTimeDimensionsToDateRange = (dashboardItem) => {
    let timeDimensions = JSON.parse(dashboardItem.vizState).query.timeDimensions
    let dateRange
    if (
        !!timeDimensions &&
        timeDimensions.length > 0 &&
        timeDimensions[0].hasOwnProperty('dateRange')
    ) {
        // if there is an existing dateRange, map it to array format 
        setDateRange(timeDimensions[0].dateRange)
        dateRange = timeDimensions[0].dateRange
            .map((date) => {
                return moment(date)
            })
    } else setDateRange()


    return dateRange
}

export default {
    getDateRange, setDateRange,
    formatTimeStrings,
    mapDateRangeToTimeDimensions,
    mapTimeDimensionsToDateRange
}